// @ts-check
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { getPartnersAction } from '../redux/actions/partner-actions';

import { makeStyles } from '@material-ui/core/styles';

import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { AddNewPartnerFab } from '../components/add-component';
import { LoadingComponent } from '../components/loading-component';
import { BackNavigationComponent } from '../../../../core/routes/components/back-navigation-component';
import LocalShipping from '@material-ui/icons/LocalShipping';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0),
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  sectionHeading: {
    margin: theme.spacing(2)
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    cursor: 'pointer'
  },
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  partnerLogo: {
    height: '2rem',
    width: '2rem',
    objectFit: 'contain',
    fontSize: '4em'
  },
  icon: {
    fontSize: '4em'
  }
}));

function Partner({ partner }) {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Paper
      className={classes.paper}
      elevation={0}
      onClick={() => history.push(`/partners/${partner.id}/view`)}
    >
      <LocalShipping className={classes.partnerLogo} fontSize="large" />
      <div>
        <b>{partner.name}</b>
      </div>
    </Paper>
  );
}

export function Partners({ partners }) {
  const renderPartners = partners.map((value, key) => {
    return (
      <Grid key={key} item xs={6} md={4}>
        <Partner partner={value} />
      </Grid>
    );
  });

  return (
    <Grid container spacing={2}>
      {renderPartners}
    </Grid>
  );
}

export default function PartnersPage() {
  const classes = useStyles();

  const { partners, loading } = useSelector((state) => state.partners);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPartnersAction());
  }, [dispatch]);

  return (
    <>
      <React.Fragment>
        <CssBaseline />
        <Container className={classes.container}>
          {loading && <LoadingComponent />}
          {!loading && (
            <>
              <BackNavigationComponent page="Partners" uri="/" />
              <AddNewPartnerFab />
              <Partners partners={partners} />
            </>
          )}
        </Container>
      </React.Fragment>
    </>
  );
}
